export class ErrorException {

  constructor(public readonly error: Error) {
  }

}
